/**
 * Copyright (c) 2018-2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author Alexander Rose <alexander.rose@weirdbyte.de>
 */
import { __assign } from "tslib";
import { MolecularSurfaceMeshVisual, MolecularSurfaceMeshParams } from '../visual/molecular-surface-mesh';
import { UnitsRepresentation } from '../units-representation';
import { ParamDefinition as PD } from '../../../mol-util/param-definition';
import { StructureRepresentationProvider, StructureRepresentationStateBuilder } from '../representation';
import { Representation } from '../../../mol-repr/representation';
import { MolecularSurfaceWireframeParams, MolecularSurfaceWireframeVisual } from '../visual/molecular-surface-wireframe';
var MolecularSurfaceVisuals = {
  'molecular-surface-mesh': function (ctx, getParams) {
    return UnitsRepresentation('Molecular surface mesh', ctx, getParams, MolecularSurfaceMeshVisual);
  },
  'molecular-surface-wireframe': function (ctx, getParams) {
    return UnitsRepresentation('Molecular surface wireframe', ctx, getParams, MolecularSurfaceWireframeVisual);
  }
};
export var MolecularSurfaceParams = __assign(__assign(__assign({}, MolecularSurfaceMeshParams), MolecularSurfaceWireframeParams), {
  visuals: PD.MultiSelect(['molecular-surface-mesh'], PD.objectToOptions(MolecularSurfaceVisuals))
});
export function getMolecularSurfaceParams(ctx, structure) {
  return PD.clone(MolecularSurfaceParams);
}
export function MolecularSurfaceRepresentation(ctx, getParams) {
  return Representation.createMulti('Molecular Surface', ctx, getParams, StructureRepresentationStateBuilder, MolecularSurfaceVisuals);
}
export var MolecularSurfaceRepresentationProvider = StructureRepresentationProvider({
  name: 'molecular-surface',
  label: 'Molecular Surface',
  description: 'Displays a molecular surface.',
  factory: MolecularSurfaceRepresentation,
  getParams: getMolecularSurfaceParams,
  defaultValues: PD.getDefaultValues(MolecularSurfaceParams),
  defaultColorTheme: {
    name: 'chain-id'
  },
  defaultSizeTheme: {
    name: 'uniform'
  },
  isApplicable: function (structure) {
    return structure.elementCount > 0;
  }
});